import { DataTable } from "@/components/DataTable";
import { ColumnDef } from "@tanstack/react-table";
import { TableControlsFooter } from "@/components/DataTable/TableControlsFooter";

const LoadingPageWorkshop = ({
  pageSize,
  columns,
  compact,
}: {
  pageSize: number;
  columns: ColumnDef<any, any>[];
  compact?: boolean;
}) => {
  return (
    <>
      <DataTable
        columns={columns}
        data={[{}, {}]}
        isLoading={true}
        loadingRows={pageSize}
        compact={compact}
      />
      <TableControlsFooter
        data={{ total: 0, pages: 1 }}
        currentPage={1}
        setCurrentPage={() => {}}
        pageSize={pageSize}
        onPageSizeChange={() => {}}
      />
    </>
  );
};

export default LoadingPageWorkshop;
